import React from 'react';
import { StationsListProps } from './StationsList.types';
import { StationDetails } from '../../../../types/LTSTypes';

const StationsList = (props: StationsListProps) => {
  const { stationsList, onClick } = props;

  const handleOnClick = (stationDetails: StationDetails) => {
    onClick(stationDetails);
  };

  return (
    <ul className="LTSPageCommon-ul">
      {stationsList.map((item, index) => (
        <li
          className="LTSPageCommon-li LTSTrainStation-StationsList-li LTSPageCommon-click-transition"
          key={`${item.code}-${index}`}
          onClick={() => handleOnClick({ stationName: item.name, stationCode: item.code })}
        >
          <span className="LTSPageCommon-text-overflow-ellipsis">{item.name}</span>
          <span>{item.code}</span>
        </li>
      ))}
    </ul>
  );
};

export default StationsList;
